import { useMutation, useQueryCache } from "react-query";
import { postNotificationStatus } from "../api";
import {
  API_KEY_GET_MANAGEABLE_NOTIFICATION,
  API_KEY_GET_MANAGEABLE_NOTIFICATIONS,
} from "../constants";

export const usePostNotificationStatus = () => {
  const queryCache = useQueryCache();
  return useMutation(postNotificationStatus, {
    onSuccess: (data, variables) => {
      queryCache.invalidateQueries(API_KEY_GET_MANAGEABLE_NOTIFICATION);
      queryCache.invalidateQueries(API_KEY_GET_MANAGEABLE_NOTIFICATIONS);
    },
  });
};
